import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_NEWRELIC_BROWSER_ENABLED = createFcmDetails('newrelic_browser_enabled', {
	owner: 'FE framework squad',
	context: 'corgi/fe',
	description: 'Used to enable the adding of the newrelic browser script in the server-rendered HTML.',
	import: false,
});
